
import baseInput from './base-input'
import MobileInput from './mobile-input'
import NavTitle from './nav-title'
import Popup from './popup'
import BaseIcon from './base-icon'
import iframeDialog from './iframe/index'

let components = {
  baseInput,  // 该系统的封装的输入框
  MobileInput, // 移动端的输入框
  NavTitle, // 移动端导航
  Popup,
  BaseIcon,
  iframeDialog
}

export default {
  install: function(Vue) {
    for (let i in components) {
      components[i].install(Vue)
    }
  }
}
